import { connect } from 'react-redux';
import LoginDialog from 'Components/Map/Components/LoginDialog';
import { setJwt, clearJwt, clearStore } from 'Actions/index';
import { IStore } from 'Components/Map/Store/index';
import { Action, Dispatch } from "redux/index";

/**
* Maps the state to their respective properties
* @param { object } state - list of properties that define the state
* @param { object } ownProps - the properties
*/
const mapStateToProps = (state: IStore, ownProps: any) => ({
    jwt: state.jwt
});

/**
* Maps actions to their respective props
* @param { action } dispatch - dispatch action 
* @param { object } ownProps - the properties
*/
const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: any) => ({
    setJwt: (jwt: string) => dispatch(setJwt(jwt)),
    clearJwt: () => dispatch(clearJwt()),
    clearStore: () => dispatch(clearStore())
});

/**
* Maps these constants defined constants to the given component
* @return { function } returns a lambda that gets called immediately with a component
*/
const LoginDialogContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginDialog);

export default LoginDialogContainer;